import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../ui/dialog";
import { Button } from "../../ui/button";

export const ForceLogout = (props) => {

  const confirmLogout = () => {
    localStorage.clear();
    // props.history.push("/login");
    window.location.pathname = "/login";
  }

  return (
    <>
      <Dialog open={true} onOpenChange={() => {}}>
        <DialogContent showClose={false}>
          <DialogHeader>
            <DialogTitle>Alert</DialogTitle>
          </DialogHeader>
          <div className="text-destructive bg-destructive/10 p-4 rounded-md border border-destructive/20 text-center"
            style={{
              fontSize: "18px",
            }}>
            <div className="font-medium">Please contact the Administrator for Permission</div>
          </div>
          <div className='flex justify-center gap-2 my-4'>
            <Button
              variant="destructive"
              onClick={confirmLogout}
            >
              OK
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ForceLogout;
